import React, { useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';

interface MemoEditDialogProps {
  open: boolean;
  memo: string;
  onClose: () => void;
  onSubmit: (memo: string) => Promise<void>;
  title?: string;
}

const MemoEditDialog: React.FC<MemoEditDialogProps> = ({
  open,
  memo,
  onClose,
  onSubmit,
  title = "メモを編集"
}) => {
  const [ editingMemo, setEditingMemo ] = useState('');
  const [ originalMemo, setOriginalMemo ] = useState('');
  const [ isSubmitting, setIsSubmitting ] = useState(false);
  // ダイアログが開いた時の初期化
  useEffect(() => {
    if (open) {
      setEditingMemo(memo || '');
      setOriginalMemo(memo || '');
    }
  }, [ open, memo ]);
  const isMemoChanged = editingMemo !== originalMemo;
  const handleSubmit = async() => {
    setIsSubmitting(true);
    try {
      await onSubmit(editingMemo);
      onClose();
    } catch (error) {
      console.error('メモの更新に失敗しました:', error);
      alert('メモの更新に失敗しました。再度お試しください。');
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <Dialog
      open={open}
      onClose={(_event, reason) => {
        // backdropClickやescapeKeyDownによる閉じるを無効化
        if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
          onClose();
        }
      }}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          multiline
          rows={6}
          fullWidth
          variant="outlined"
          value={editingMemo}
          onChange={(e) => setEditingMemo(e.target.value)}
          placeholder="メモを入力してください"
          sx={{ mt: 1 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>キャンセル</Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={isSubmitting || !isMemoChanged}
        >
          {isSubmitting ? '登録中...' : '登録'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default MemoEditDialog;
